import { useState, useEffect, useCallback } from "react";
import { Form, notification } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import $axios from "../services/axios";
import axios from "axios";
import { moveToFirst, removeDiacritics, formatString } from "../helpers/utils";

export const useBookingLogic = ({ setLoading, setStep }) => {
  const [countries, setCountries] = useState([]);
  const [filterCountries, setFilterCountries] = useState([]);
  const [chooseAddStep, setChooseAddStep] = useState(1);
  const [hotels, setHotels] = useState([]);
  const [openChooseHotel, setOpenChooseHotel] = useState(false);
  const [hotelSelected, setHotelSelected] = useState(null);
  const [form] = Form.useForm();
  const [provinces, setProvinces] = useState([]);
  const [filterProvinces, setFilterProvinces] = useState([]);
  const [searched, setSearched] = useState(false);
  const [addPrice] = useState(0);
  const [openDrawerChooseAdd, setOpenDrawerChooseAdd] = useState(false);
  const [openDrawerChooseHotel, setOpenDrawerChooseHotel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermHotel, setSearchTermHotel] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [displayHotels, setDisplayHotels] = useState([]);
  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [typeCalendar, setTypeCalendar] = useState("");
  const [minDateCalendar, setMinDateCalendar] = useState(new Date());
  const [countryDetect, setCountryDetect] = useState("");
  const [provinceDetect, setProvinceDetect] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [filterHotel, setFilterHotel] = useState([
    { value: "", name: "Tất cả" },
  ]);
  const [filter, setFilter] = useState({
    address: "",
    country: "",
    star: 6,
  });
  const [hotelSearch, setHotelSearch] = useState("");

  const getPlaceDetailFromLatLng = useCallback(async (lat, lng) => {
    const apiKey = "tNjW3KnNdwrAsbelORJR7JirivVM2WgmVrgVTiK3";
    const url = `https://rsapi.goong.io/Geocode?latlng=${lat},${lng}&api_key=${apiKey}`;

    try {
      const response = await axios.get(url);
      if (response.data.results && response.data.results.length > 0) {
        const place = response.data.results[0];
        const regionName = formatString(place.compound.province || "");
        return {
          regionName,
          placeName: place.name,
          description: place?.formatted_address || "",
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
          place_id: place.place_id,
          compound: {
            ...place.compound,
            country: place.compound.country || "Việt Nam",
          },
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }, []);

  const detectLocation = useCallback(async () => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const placeDetail = await getPlaceDetailFromLatLng(latitude, longitude);

        if (placeDetail) {
          setProvinceDetect(placeDetail.compound.province);
          setCountryDetect(placeDetail.compound.country);
        }
      },
      (err) => {
        console.error("Lỗi khi lấy vị trí: ", err.message);
      },
    );
  }, [getPlaceDetailFromLatLng]);

  const getCountries = useCallback(async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/v1/api/hotel-tripi/hotel-content/countries`,
      );
      const _countries = moveToFirst(res.data.data.items, "id", 1);
      setCountries(_countries);
      setFilterCountries(_countries);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const getProvinces = useCallback(async (countryId) => {
    setLoadingLocation(true);
    try {
      const res = await $axios.$get(
        `/v1/api/hotel-tripi/hotel-content/provinces?countryId=${countryId}`,
      );
      let _provinces = moveToFirst(res.data.data.items, "id", 11);
      _provinces = moveToFirst(res.data.data.items, "id", 33);
      setProvinces(_provinces);
      setFilterProvinces(res.data.data.items);
    } catch (error) {
    } finally {
      setLoadingLocation(false);
    }
  }, []);

  const handleGetHotels = useCallback(async () => {
    try {
      const res = await $axios.$get(
        `/v1/api/hotel-tripi/getHotelMytours?name=&city=${filter.address}&startNumber=${_.get(filter, "star", 6) === 6 ? "" : _.get(filter, "star", 6)}`,
      );
      const _hotels = res.data.data.data;
      setFilterHotel([{ value: "", name: "Tất cả" }, ..._hotels]);
      setHotels(_hotels);
    } catch (error) {
      setHotels([]);
      notification.error({
        description: `Có lỗi xảy ra vui lòng thử lại!`,
      });
    }
  }, [filter]);

  const processLocationDetect = useCallback(
    async (countryId) => {
      setLoading(true);
      try {
        const res = await $axios.$get(
          `/v1/api/hotel-tripi/hotel-content/provinces?countryId=${countryId}`,
        );
        let _provinces = moveToFirst(res.data.data.items, "id", 11);
        _provinces = moveToFirst(res.data.data.items, "id", 33);
        setProvinces(_provinces);
        setFilterProvinces(res.data.data.items);
        const provinceName = _.get(
          _.find(res.data.data.items, (p) => p.name === provinceDetect),
          "name",
          "",
        );
        const countryCode = _.get(
          _.find(countries, (p) => p.id === countryId),
          "code",
          "",
        );
        if (provinceName && countryCode) {
          setFilter((prev) => ({
            ...prev,
            country: countryCode,
            address: provinceName,
          }));
          setChooseAddStep(2);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
    [countries, provinceDetect, setLoading],
  );

  useEffect(() => {
    detectLocation();
    getCountries();
  }, [detectLocation, getCountries]);

  useEffect(() => {
    if (filter.country && filter.address) {
      handleGetHotels();
      setHotelSearch("");
      setSearched(false);
    }
  }, [filter, handleGetHotels]);

  useEffect(() => {
    if (countries.length > 0 && countryDetect && provinceDetect) {
      const countryId = _.get(
        _.find(countries, (c) => c.name === countryDetect),
        "id",
        "",
      );
      if (countryId) {
        processLocationDetect(countryId);
      }
    }
  }, [countries, countryDetect, provinceDetect, processLocationDetect]);

  useEffect(() => {
    if (chooseAddStep === 1) {
      setFilterCountries(
        _.filter(countries, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(`${item.name} ${item.code}`)),
            _.toLower(removeDiacritics(searchTerm)),
          );
        }),
      );
    }
    if (chooseAddStep === 2) {
      setFilterProvinces(
        _.filter(provinces, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(item.name)),
            _.toLower(removeDiacritics(searchTerm)),
          );
        }),
      );
    }
  }, [searchTerm, chooseAddStep, countries, provinces]);

  useEffect(() => {
    if (searchTermHotel) {
      setFilterHotel(
        _.filter(hotels, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(item.name)),
            _.toLower(removeDiacritics(searchTermHotel)),
          );
        }),
      );
    } else {
      setFilterHotel([{ value: "", name: "Tất cả" }, ...hotels]);
    }
  }, [searchTermHotel, hotels]);

  const onOpenChange = (type) => {
    setValueCalendar(form.getFieldValue(type) ?? new Date());
    setOpenCalendar(true);
    setTypeCalendar(type);
    if (type === "returnDate") {
      setMinDateCalendar(new Date(form.getFieldValue("departDate")));
    } else {
      setMinDateCalendar(new Date());
    }
  };

  const setValue = (value) => {
    form.setFieldValue(typeCalendar, dayjs(value));
    setValueCalendar(value);
    if (
      typeCalendar === "departDate" &&
      dayjs(value) >= form.getFieldValue("returnDate")
    ) {
      const newReturnDate = dayjs(value).add(1, "day");
      form.setFieldValue("returnDate", newReturnDate);
    }
    setOpenCalendar(false);
  };

  const handleGetListHotelAvailable = async (values) => {
    if (values.numRooms > values.numAdults) {
      notification.warning({
        description: `Số phòng cần nhỏ hơn hoặc bằng số người lớn!`,
      });
      return;
    }
    if (!filter.address) {
      notification.warning({
        description: `Vui lòng chọn tỉnh thành cụ thể!`,
      });
      return;
    }

    setLoading(true);
    const specialHotelId = 29739;
    let specialHotel = hotels.find((h) => h.id === specialHotelId);
    let otherHotels = hotels.filter((h) => h.id !== specialHotelId);

    let hotelsId = hotelSearch
      ? [[hotelSearch]]
      : _.chunk(
        otherHotels.map((h) => h.id),
        20,
      );

    const body = {
      StayCheckIn: dayjs(values.departDate).format("YYYY-MM-DD"),
      StayCheckOut: dayjs(values.returnDate).format("YYYY-MM-DD"),
      Nationality: filter.country,
      OccupanciesAdults: values.numAdults + values.numChilds,
      OccupanciesChildren: 0,
      LanguageCode: "vi",
      NumberOfUnits: values.numRooms,
      RealTimeSearch: true,
    };

    const callApiForChunk = async (chunk) => {
      try {
        const response = await $axios.$post("/v1/api/hotel-tripi/hotel-avail", {
          ...body,
          Hotels: chunk,
        });
        return _.get(response, "data.data.hotels", []);
      } catch (error) {
        return [];
      }
    };

    const callApiForChunkProperty = async (chunk) => {
      try {
        const response = await $axios.$post(
          `/v1/api/hotel-tripi/hotel-content/properties/content`,
          { PropertyId: chunk },
        );
        return _.get(response, "data.data.items", []);
      } catch (error) {
        return [];
      }
    };

    try {
      const results = await Promise.all(hotelsId.map(callApiForChunk));
      let allHotelsHasData = _.filter(
        _.flatten(results),
        (item) => item.status !== "NoRoom",
      );

      if (specialHotel) {
        const specialHotelData = await callApiForChunk([specialHotelId]);
        if (
          specialHotelData.length > 0 &&
          specialHotelData[0].status !== "NoRoom"
        ) {
          allHotelsHasData.push(specialHotelData[0]);
        }
      }

      const listIdsHotelHasData = _.chunk(
        allHotelsHasData.map((h) => h.id),
        20,
      );
      const hotelProperty = _.flatten(
        await Promise.all(listIdsHotelHasData.map(callApiForChunkProperty)),
      );

      allHotelsHasData = allHotelsHasData.map((hotel) => {
        const property = hotelProperty.find((h) => h.id === hotel.id);
        if (property) delete property.rooms;

        hotel.rooms = hotel.rooms.map((room) => {
          room["minPrice"] = _.minBy(
            room.rates,
            "rateaftertaxtotal",
          ).rateaftertaxtotal;
          room["maxPrice"] = _.maxBy(
            room.rates,
            "rateaftertaxtotal",
          ).rateaftertaxtotal;
          return room;
        });
        hotel["minPrice"] = Math.min(...hotel.rooms.map((r) => r.minPrice));
        hotel["maxPrice"] = Math.max(...hotel.rooms.map((r) => r.maxPrice));
        return _.merge({}, hotel, property ? property : {});
      });
      setDisplayHotels(_.orderBy(allHotelsHasData, ["maxPrice"], "asc"));
      setSortBy("price:asc");
    } catch (error) {
      setDisplayHotels([]);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  };

  const handleSelectAdd = (value, type = "country" | "province" | "hotel") => {
    if (type === "hotel") {
      setHotelSearch(value);
      setOpenDrawerChooseHotel(false);
      setSearchTermHotel("");
      setFilterHotel([{ value: "", name: "Tất cả" }, ...hotels]);
      return;
    }
    if (type === "country") {
      setChooseAddStep(2);
      getProvinces(value);
      setFilter((prev) => ({
        ...prev,
        country: _.find(countries, (c) => c.id === value).code,
        address: "",
      }));
    } else {
      setOpenDrawerChooseAdd(false);
      setFilter((prev) => ({
        ...prev,
        address: _.get(
          _.find(provinces, (c) => c.id === value),
          "name",
        ),
      }));
    }
    setSearchTerm("");
  };

  const handleSortPriceHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "price:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "asc"));
      setSortBy("price:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "desc"));
      setSortBy("price:desc");
    }
  };

  const handleSortStarHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "star:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["starNumber"], "asc"));
      setSortBy("star:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["starNumber"], "desc"));
      setSortBy("star:desc");
    }
  };

  const setFormValueAndSearch = (addressName) => {
    setFilter((prev) => ({
      ...prev,
      address: addressName,
      country: "VN",
    }));
    window.scrollTo({ top: 400, behavior: "smooth" });
  };

  return {
    form,
    countries,
    filterCountries,
    chooseAddStep,
    setChooseAddStep,
    hotels,
    openChooseHotel,
    setOpenChooseHotel,
    hotelSelected,
    setHotelSelected,
    provinces,
    filterProvinces,
    searched,
    setSearched,
    addPrice,
    openDrawerChooseAdd,
    setOpenDrawerChooseAdd,
    openDrawerChooseHotel,
    setOpenDrawerChooseHotel,
    searchTerm,
    setSearchTerm,
    searchTermHotel,
    setSearchTermHotel,
    currentPage,
    setCurrentPage,
    pageSize,
    loadingLocation,
    displayHotels,
    setDisplayHotels,
    valueCalendar,
    openCalendar,
    setOpenCalendar,
    typeCalendar,
    minDateCalendar,
    sortBy,
    filterHotel,
    filter,
    setFilter,
    hotelSearch,
    setHotelSearch,
    onOpenChange,
    setValue,
    handleGetListHotelAvailable,
    getProvinces,
    handleSelectAdd,
    handleSortPriceHotel,
    handleSortStarHotel,
    setFormValueAndSearch,
  };
};
